import React from "react"

export default function PageHeader({ text }) {
  return (
    <h1 className="text-3xl md:text-5xl font-bold leading-tight pb-8 md:pb-16 text-center">
      {text}
    </h1>
  )
}
